/*eslint-disable*/
import React from 'react';
import ImageComponent from '../../../atoms/Image';
import { Text } from '../../../atoms/Text';
import { Timer } from '../../../atoms/Time';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import './styles.scss';

export const Counter = ({ text, imagePng, imageWebp, activeCounter, startDate, finalDate, resetDays }) => {
  const isDesktop = useBreakpoint('large-min');
  const pngSrc = isDesktop ? imagePng?.image_desktop?.url || '' : imagePng?.image_mobile?.url || '';
  const webpSrc = isDesktop ? imageWebp?.image_desktop?.url || '' : imageWebp?.image_mobile?.url || '';

  return (
    <div className="counter">
      <div className="counter__image">
        <ImageComponent pngSrc={pngSrc} webpSrc={webpSrc} alt="Image" className="!relative" fill />
      </div>
      <div className="counter__information">
        <Text text={text} customClassText="counter__information--text" />
        {activeCounter && <Timer startDate={startDate} finalDate={finalDate} resetDays={resetDays} />}
      </div>
    </div>
  );
};

export const Informative = ({ text, imagePng, imageWebp }) => {
  const isDesktop = useBreakpoint('large-min');
  const pngSrc = isDesktop ? imagePng?.image_desktop?.url || '' : imagePng?.image_mobile?.url || '';
  const webpSrc = isDesktop ? imageWebp?.image_desktop?.url || '' : imageWebp?.image_mobile?.url || '';

  return (
    <div className="informative">
      <div className="informative__image">
        <ImageComponent pngSrc={pngSrc} webpSrc={webpSrc} alt="Image" className="!relative" />
      </div>
      <Text text={text} customClassText="informative__text" />
    </div>
  );
};

export const Redirection = ({ text, imagePng, imageWebp, activeBtnGo }) => {
  const isDesktop = useBreakpoint('large-min');
  const pngSrc = isDesktop ? imagePng?.image_desktop?.url || '' : imagePng?.image_mobile?.url || '';
  const webpSrc = isDesktop ? imageWebp?.image_desktop?.url || '' : imageWebp?.image_mobile?.url || '';

  return (
    <div className="redirection">
      <div className="redirection__image">
        <ImageComponent pngSrc={pngSrc} webpSrc={webpSrc} alt="Image" className="!relative" />
      </div>
      <Text text={text} />
    </div>
  );
};
